// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SalutationsPlaceholder_body__DLXTt {
  display: flex;
  justify-content: space-evenly;
  flex: start 1;
}
.SalutationsPlaceholder_block__tOGQQ {
  width: 90%;
  margin-bottom: 10px;
}

.SalutationsPlaceholder_block_title__gY\\+Ho {
  margin-top: 2px;
  margin-bottom: 2px;
}

.SalutationsPlaceholder_block_body__A0L3k {
  display: flex;
  align-items: center;
  border: 2px solid lightgray;
  border-radius: 6px;
  padding: 5px;
}
.SalutationsPlaceholder_block_inputs__WWdCQ {
  /* display: flex; */
  width: 90%;
  margin: 0;
}
.SalutationsPlaceholder_block_icon__rPruD {
  margin-left: 3%;
}
.SalutationsPlaceholder_block_label__0iInu {
  margin-right: 12%;
  width: 8%;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/SalutationsPlaceholderPopup/SalutationsPlaceholder.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAW;AACb;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,SAAS;AACX","sourcesContent":[".body {\n  display: flex;\n  justify-content: space-evenly;\n  flex: start;\n}\n.block {\n  width: 90%;\n  margin-bottom: 10px;\n}\n\n.block_title {\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n\n.block_body {\n  display: flex;\n  align-items: center;\n  border: 2px solid lightgray;\n  border-radius: 6px;\n  padding: 5px;\n}\n.block_inputs {\n  /* display: flex; */\n  width: 90%;\n  margin: 0;\n}\n.block_icon {\n  margin-left: 3%;\n}\n.block_label {\n  margin-right: 12%;\n  width: 8%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `SalutationsPlaceholder_body__DLXTt`,
	"block": `SalutationsPlaceholder_block__tOGQQ`,
	"block_title": `SalutationsPlaceholder_block_title__gY+Ho`,
	"block_body": `SalutationsPlaceholder_block_body__A0L3k`,
	"block_inputs": `SalutationsPlaceholder_block_inputs__WWdCQ`,
	"block_icon": `SalutationsPlaceholder_block_icon__rPruD`,
	"block_label": `SalutationsPlaceholder_block_label__0iInu`
};
export default ___CSS_LOADER_EXPORT___;
